import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation MaintenanceTypeTasks($companyId: ID!, $attributes: MaintenanceTypeTaskAttributes!) {
    createMaintenanceTypeTask(companyId: $companyId, attributes: $attributes) {
      maintenanceTypeTask {
        id
        ...CreatedMaintenanceTypeTask
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedMaintenanceTypeTask on MaintenanceTypeTask {
     id
     taskType
     name
  }
`
